import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import { BusinessProvider } from './context/BusinessContext';
import PrivateRoute from './components/PrivateRoute';
import ClientRedirect from './components/ClientRedirect';
import MainLayout from './components/Layout/MainLayout';
import Login from './pages/Login';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import POS from './pages/POS';
import Products from './pages/Products';
import Sales from './pages/Sales';
import Orders from './pages/Orders';
import Reports from './pages/Reports';
import Invoices from './pages/Invoices';
import ContactMessages from './pages/ContactMessages';
import Customers from './pages/Customers';
import Settings from './pages/Settings';
import Catalog from './pages/Catalog';
import CatalogClient from './pages/CatalogClient';
import MyOrders from './pages/MyOrders';
import Profile from './pages/Profile';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentFailure from './pages/PaymentFailure';
import PaymentPending from './pages/PaymentPending';
import './styles/index.css';
import PublicThemeProvider from './components/PublicThemeProvider';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BusinessProvider>
          <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <Routes>
              {/* Ruta pública: Home/Landing Page */}
              <Route 
                path="/" 
                element={
                  <ClientRedirect>
                    <PublicThemeProvider><Home /></PublicThemeProvider>
                  </ClientRedirect>
                } 
              />

              {/* Vista pública accesible también con una sesión iniciada */}
              <Route path="/sitio" element={<PublicThemeProvider><Home /></PublicThemeProvider>} />
              <Route path="/cava" element={<PublicThemeProvider><Catalog /></PublicThemeProvider>} />
              
              {/* Ruta pública: Login */}
              <Route 
                path="/login" 
                element={
                  <ClientRedirect>
                    <PublicThemeProvider><Login /></PublicThemeProvider>
                  </ClientRedirect>
                } 
              />
              
              {/* Ruta pública: Catálogo (mantener por compatibilidad) */}
              <Route 
                path="/catalog" 
                element={
                  <ClientRedirect>
                    <PublicThemeProvider><Catalog /></PublicThemeProvider>
                  </ClientRedirect>
                } 
              />
              
              {/* Ruta privada: Catálogo para clientes autenticados */}
              <Route
                path="/catalog-client"
                element={
                  <PrivateRoute>
                    <MainLayout>
                      <CatalogClient />
                    </MainLayout>
                  </PrivateRoute>
                }
              />

              {/* Ruta privada: Mis Pedidos (Clientes) */}
              <Route
                path="/my-orders"
                element={
                  <PrivateRoute>
                    <MainLayout>
                      <MyOrders />
                    </MainLayout>
                  </PrivateRoute>
                }
              />

              {/* Ruta privada: Perfil (Clientes) */}
              <Route
                path="/profile"
                element={
                  <PrivateRoute>
                    <MainLayout>
                      <Profile />
                    </MainLayout>
                  </PrivateRoute>
                }
              />
              
              {/* Rutas públicas: Confirmación de pagos */}
              <Route 
                path="/payment/success" 
                element={
                  <ClientRedirect>
                    <PublicThemeProvider><PaymentSuccess /></PublicThemeProvider>
                  </ClientRedirect>
                } 
              />
              <Route 
                path="/payment/failure" 
                element={
                  <ClientRedirect>
                    <PublicThemeProvider><PaymentFailure /></PublicThemeProvider>
                  </ClientRedirect>
                } 
              />
              <Route 
                path="/payment/pending" 
                element={
                  <ClientRedirect>
                    <PublicThemeProvider><PaymentPending /></PublicThemeProvider>
                  </ClientRedirect>
                } 
              />
              
              {/* Rutas privadas */}
              <Route
                path="/dashboard"
                element={
                  <PrivateRoute>
                    <MainLayout>
                      <Dashboard />
                    </MainLayout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/pos"
                element={
                  <PrivateRoute>
                    <MainLayout>
                      <POS />
                    </MainLayout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/products"
                element={
                  <PrivateRoute requireAdmin>
                    <MainLayout>
                      <Products />
                    </MainLayout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/sales"
                element={
                  <PrivateRoute>
                    <MainLayout>
                      <Sales />
                    </MainLayout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/orders"
                element={
                  <PrivateRoute>
                    <MainLayout>
                      <Orders />
                    </MainLayout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/reports"
                element={
                  <PrivateRoute requireAdmin>
                    <MainLayout>
                      <Reports />
                    </MainLayout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/invoices"
                element={
                  <PrivateRoute>
                    <MainLayout>
                      <Invoices />
                    </MainLayout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/customers"
                element={
                  <PrivateRoute>
                    <MainLayout>
                      <Customers />
                    </MainLayout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/contact-messages"
                element={
                  <PrivateRoute requireAdmin>
                    <MainLayout>
                      <ContactMessages />
                    </MainLayout>
                  </PrivateRoute>
                }
              />
              {/* Redireccionar rutas antiguas a Configuración */}
              <Route path="/categories" element={<Navigate to="/settings" replace />} />
              <Route path="/brands" element={<Navigate to="/settings" replace />} />
              
              <Route
                path="/settings"
                element={
                  <PrivateRoute requireAdmin>
                    <MainLayout>
                      <Settings />
                    </MainLayout>
                  </PrivateRoute>
                }
              />
              
              {/* Ruta 404 - redirigir a home */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Router>
        </BusinessProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;

